import "./password.scss";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import AlertComponent from "../AlertComponent";
import { getAuth, EmailAuthProvider, reauthenticateWithCredential, updatePassword } from "firebase/auth";

function Password(props) {
  const [oldPassword, setOldPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmNewPassword, setConfirmNewPassword] = useState(null);
  const auth = getAuth();
  const currentUser = auth?.currentUser;

  const checkEmailAndPassword = () => {
    const credential = EmailAuthProvider.credential(props.jwtInfo.email, oldPassword);

    reauthenticateWithCredential(currentUser, credential)
      .then(() => {
        updatePassword(currentUser, confirmNewPassword)
          .then(() => {
            setOldPassword("");
            setNewPassword("");
            setConfirmNewPassword("");
            return AlertComponent("Success", "Password has been changed.");
          })
          .catch((error) => {
            return AlertComponent("Error", "Something went wrong. Try again later. " + error, { icon: `error` });
          });
      })
      .catch((error) => {
        return AlertComponent("Error", "The password is wrong. Check and try again.", { icon: `error` });
      });
  };

  const handleSubmit = () => {
    if (!oldPassword) {
      return AlertComponent("Error", "Old Password is required", { icon: `error` });
    }

    if (!newPassword || newPassword.length < 8) {
      return AlertComponent("Error", "Password needs at least 8 characters", { icon: `error` });
    }

    if (!confirmNewPassword || confirmNewPassword.length < 8) {
      return AlertComponent("Error", "Password confirmation needs at least 8 characters", { icon: `error` });
    }

    if (newPassword != confirmNewPassword) {
      return AlertComponent("Error", "Passwords do NOT match", { icon: `error` });
    }

    checkEmailAndPassword();
  };

  const handleUploadImage = () => {
    AlertComponent("Upload", "The upload component will be rendered");
  };
  return (
    <div className="password-tab">
      <h2>Password</h2>

      <div className="profile-section">
        <FieldText
          type="password"
          onChange={(x) => setOldPassword(x.target.value)}
          label="Old password"
          placeholder="Old password"
          value={oldPassword}
          required={true}
          inputClassName={`password-input-option`}
        />
      </div>

      <div className="profile-section">
        <FieldText
          type="password"
          onChange={(x) => setNewPassword(x.target.value)}
          label="New Password"
          placeholder="New Password"
          value={newPassword}
          required={true}
          inputClassName={`password-input-option`}
          information={`Minimum 8 characters`}
        />
      </div>

      <div className="profile-section">
        <FieldText
          type="password"
          onChange={(x) => setConfirmNewPassword(x.target.value)}
          label="Confirm new password"
          placeholder="Confirm new password"
          value={confirmNewPassword}
          required={true}
          inputClassName={`password-input-option`}
          information={`Minimum 8 characters`}
        />
      </div>

      <div className="profile-section">
        <Button className="big-save-button" onClick={handleSubmit}>Change password</Button>
      </div>
    </div>
  );
}

export default Password;
